const testimonials = [
	{
		body: 'Laborum quis quam. Dolorum et ut quod quia. Voluptas numquam delectus nihil. Aut enim doloremque et ipsam.',
		author: {
			name: 'Leslie Alexander',
			handle: 'lesliealexander',
			imageUrl:
				'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
		}
	},
	{
		body: 'Aut reprehenderit voluptatem eum asperiores beatae id. Iure molestiae ipsam ut officia rem nulla blanditiis.',
		author: {
			name: 'Lindsay Walton',
			handle: 'lindsaywalton',
			imageUrl:
				'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
		}
	},
	{
		body: 'Voluptas quos itaque ipsam in voluptatem est. Iste eos blanditiis repudiandae. Earum deserunt enim molestiae ipsum perferendis recusandae saepe corrupti.',
		author: {
			name: 'Tom Cook',
			handle: 'tomcook',
			imageUrl:
				'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
		}
	},
	{
		body: 'Molestias ea earum quos nostrum doloremque sed. Quaerat quasi aut velit incidunt excepturi rerum voluptatem minus harum.',
		author: {
			name: 'Leonard Krasner',
			handle: 'leonardkrasner',
			imageUrl:
				'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
		}
	}
	// More testimonials...
];

const Enurm = () => {
	return (
		<div className='bg-gray-50 py-24 sm:py-32'>
			<div className='mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8'>
				<h2 className='text-center text-base/7 font-semibold text-indigo-600'>
					Descubre la mejor herramienta de preparacion para el ENURM
				</h2>
				{/* <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
            Everything you need to deploy your app
          </p> */}
				<div className='mt-10 grid gap-4 sm:mt-16 lg:grid-cols-3 lg:grid-rows-2'>
					<div className='relative lg:row-span-2'>
						<div className='absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]' />
						<div className='relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] lg:rounded-l-[calc(2rem+1px)]'>
							<div className='px-8 pt-8 pb-3 sm:px-10 sm:pt-10 sm:pb-0'>
								<p className='mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center'>
									Mobile friendly
								</p>
								<p className='mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center'>
									Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure
									qui lorem cupidatat commodo.
								</p>
							</div>
							<div className='@container relative min-h-[30rem] w-full grow max-lg:mx-auto max-lg:max-w-sm'>
								<div className='absolute inset-x-10 top-10 bottom-0 overflow-hidden rounded-t-[12cqw] border-x-[3cqw] border-t-[3cqw] border-gray-700 bg-gray-900 shadow-2xl'>
									<img
										alt=''
										className='size-full object-cover object-top'
										src='https://tailwindcss.com/plus-assets/img/component-images/bento-03-mobile-friendly.png'
									/>
								</div>
							</div>
						</div>
						<div className='pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-l-[2rem]' />
					</div>
					<div className='relative max-lg:row-start-1'>
						<div className='absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]' />
						<div className='relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]'>
							<div className='px-8 pt-8 sm:px-10 sm:pt-10'>
								<p className='mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center'>
									Performance
								</p>
								<p className='mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center'>
									Lorem ipsum, dolor sit amet consectetur adipisicing elit
									maiores impedit.
								</p>
							</div>
							<div className='flex flex-1 items-center justify-center px-8 max-lg:pt-10 max-lg:pb-12 sm:px-10 lg:pb-2'>
								<img
									alt=''
									className='w-full max-lg:max-w-xs'
									src='https://tailwindcss.com/plus-assets/img/component-images/bento-03-performance.png'
								/>
							</div>
						</div>
						<div className='pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 max-lg:rounded-t-[2rem]' />
					</div>
					<div className='relative max-lg:row-start-3 lg:col-start-2 lg:row-start-2'>
						<div className='absolute inset-px rounded-lg bg-white' />
						<div className='relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)]'>
							<div className='px-8 pt-8 sm:px-10 sm:pt-10'>
								<p className='mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center'>
									Security
								</p>
								<p className='mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center'>
									Morbi viverra dui mi arcu sed. Tellus semper adipiscing
									suspendisse semper morbi.
								</p>
							</div>
							<div className='@container flex flex-1 items-center max-lg:py-6 lg:pb-2'>
								<img
									alt=''
									className='h-[min(152px,40cqw)] object-cover'
									src='https://tailwindcss.com/plus-assets/img/component-images/bento-03-security.png'
								/>
							</div>
						</div>
						<div className='pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5' />
					</div>
					<div className='relative lg:row-span-2'>
						<div className='absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]' />
						<div className='relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-r-[calc(2rem+1px)]'>
							<div className='px-8 pt-8 pb-3 sm:px-10 sm:pt-10 sm:pb-0'>
								<p className='mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center'>
									Powerful APIs
								</p>
								<p className='mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center'>
									Sit quis amet rutrum tellus ullamcorper ultricies libero dolor
									eget sem sodales gravida.
								</p>
							</div>
							<div className='relative min-h-[30rem] w-full grow'>
								<div className='absolute top-10 right-0 bottom-0 left-10 overflow-hidden rounded-tl-xl bg-gray-900 shadow-2xl'>
									<div className='flex bg-gray-800/40 ring-1 ring-white/5'>
										<div className='-mb-px flex text-sm/6 font-medium text-gray-400'>
											<div className='border-r border-b border-r-white/10 border-b-white/20 bg-white/5 px-4 py-2 text-white'>
												NotificationSetting.jsx
											</div>
											<div className='border-r border-gray-600/10 px-4 py-2'>
												App.jsx
											</div>
										</div>
									</div>
									<div className='px-6 pt-6 pb-14'>
										{/* Your code example */}
									</div>
								</div>
							</div>
						</div>
						<div className='pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]' />
					</div>
				</div>
			</div>
			<div className='bg-white py-24 sm:py-32'>
				<div className='mx-auto max-w-7xl px-6 lg:px-8'>
					<div className='mx-auto max-w-2xl text-center'>
						<h2 className='text-base/7 font-semibold text-indigo-600'>
							Testimonios
						</h2>
						<p className='mt-2 text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl'>
							Hemos ayudado a muchos estudiantes a alcanzar sus metas
						</p>
					</div>
					<div className='mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none'>
						<div className='mt-8 sm:-mx-4 sm:columns-2 lg:colums-3'>
							{testimonials.map((testimonial) => (
								<div
									key={testimonial.author.handle}
									className='pt-8 sm:inline-block sm:w-full sm:px-4'>
									<figure className='rounded-2xl bg-gray-100 p-8 text-sm/6'>
										<blockquote className='text-gray-900'>
											<p>{`“${testimonial.body}”`}</p>
										</blockquote>
										<figcaption className='mt-6 flex items-center gap-x-4'>
											<img
												alt=''
												className='w-10 h-10 rounded-full bg-gray-50'
												src={testimonial.author.imageUrl}
											/>
											<div>
												<div className='font-semibold text-gray-900'>
													{testimonial.author.name}
												</div>
												<div className='text-gray-600'>{`@${testimonial.author.handle}`}</div>
											</div>
										</figcaption>
									</figure>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Enurm;
